import dayjs from '~/common/dayjs';
import {
    CYCLE_FIRST_DAY,
    CYCLE_LAST_DAY,
    URGENCY_TEST_TIME_ZONE
} from '~/components/Membership/constants/membershipData';
import { convertMillisecondsToTime } from '~/utils/date.utils';

export const getUrgencyTimeLeft = () => {
    const today = dayjs().tz(URGENCY_TEST_TIME_ZONE);

    //Get the current time:
    const currentDate = today.valueOf();
    const endDate = dayjs()
        .tz(URGENCY_TEST_TIME_ZONE)
        .weekday(CYCLE_LAST_DAY)
        .endOf('day')
        .valueOf();

    // Get the time left in milliseconds:
    const diff = endDate - currentDate;

    //check if current day is inside the cycle period:
    if (today.day() > CYCLE_LAST_DAY || today.day() < CYCLE_FIRST_DAY) {
        return null;
    }

    // Convert milliseconds into hours, minutes and seconds:
    return convertMillisecondsToTime(diff);
};

export function isUrgentCouponActive() {
    const currentDay = dayjs().tz(URGENCY_TEST_TIME_ZONE).day();
    return currentDay >= CYCLE_FIRST_DAY && currentDay <= CYCLE_LAST_DAY;
}
